import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import { ArrowLeft, Paperclip, Loader2 } from "lucide-react";
import api from "../lib/api";
import { resolveImage, fmtPubDate } from "../lib/cms";

export default function Article() {
  const { slug } = useParams();
  const [a, setA] = useState(undefined);
  useEffect(() => {
    setA(undefined);
    api.get(`/public/articles/${slug}`).then(({ data }) => setA(data)).catch(() => setA(null));
  }, [slug]);

  if (a === undefined) return <div className="flex min-h-[60vh] items-center justify-center"><Loader2 className="animate-spin text-gold-deep" size={32} /></div>;
  if (a === null) {
    return (
      <div className="container-lodge min-h-[60vh] pt-40" data-testid="article-not-found">
        <h1 className="display-h2 text-sapphire-deep">Article not found.</h1>
        <Link to="/news" className="link-underline mt-6">Back to News</Link>
      </div>
    );
  }
  const d = a.data;
  return (
    <article className="bg-paper-texture bg-parchment pb-24 pt-32" data-testid="article-page">
      <div className="container-lodge max-w-3xl">
        <Link to="/news" className="inline-flex items-center gap-2 font-sans text-xs uppercase tracking-widest text-sapphire-deep/60 hover:text-gold-deep" data-testid="article-back">
          <ArrowLeft size={14} /> All news
        </Link>
        <p className="mt-8 font-sans text-xs font-semibold uppercase tracking-[0.28em] text-gold-deep">{fmtPubDate(d.publish_date)}</p>
        <h1 className="display-h1 mt-3 text-sapphire-deep" data-testid="article-title">{d.title}</h1>
        {d.excerpt && <p className="mt-5 font-display text-2xl italic leading-relaxed text-charcoal/70">{d.excerpt}</p>}
        {d.cover_image && (
          <div className="mt-10 overflow-hidden rounded-2xl shadow-heritage">
            <img src={resolveImage(d.cover_image)} alt="" className="aspect-[16/9] w-full object-cover" data-testid="article-cover" />
          </div>
        )}
        <div className="prose-article mt-10" data-testid="article-body" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(d.body || "") }} />
        {d.attachments?.length > 0 && (
          <div className="mt-12 rounded-2xl border border-sapphire-deep/10 bg-white p-6" data-testid="article-attachments">
            <p className="font-sans text-xs font-semibold uppercase tracking-widest text-stonegrey">Attachments</p>
            <ul className="mt-3 space-y-2">
              {d.attachments.map((f) => (
                <li key={f.ref}>
                  <a href={resolveImage(f.ref)} target="_blank" rel="noreferrer" className="link-underline text-sm"><Paperclip size={14} /> {f.name}</a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </article>
  );
}
